import { render, staticRenderFns } from "./Visa.vue?vue&type=template&id=00b3693b&scoped=true"
import script from "./Visa.vue?vue&type=script&lang=js"
export * from "./Visa.vue?vue&type=script&lang=js"
import style0 from "./Visa.vue?vue&type=style&index=0&id=00b3693b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b3693b",
  null
  
)

export default component.exports